import { render, staticRenderFns } from "./record2.vue?vue&type=template&id=47d3953f"
import script from "./record2.vue?vue&type=script&lang=js"
export * from "./record2.vue?vue&type=script&lang=js"
import style0 from "./record2.vue?vue&type=style&index=0&id=47d3953f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports